<script setup lang="ts">
import ImageRemote from '../../mixit-ui/components/media/ImageRemote.vue';
import type { SearchArticle } from '@/services-new/searchService';

defineProps<{
  article: SearchArticle
}>()
</script>

<template>
  <article class="rounded-sm bg-white overflow-hidden flex flex-row">
    <ImageRemote
      v-if="article.image"
      :data="article.image"
      :alt="article.title"
      img-class="w-21 sm:w-20 h-full sm:h-16 object-cover"
      loading="lazy"
    />
    <a
      :href="article.permalink"
      class="flex flex-col gap-2 sm:flex-row justify-between sm:items-center text-brown-600 px-4 sm:px-6 sm:py-2 py-4 flex-1 font-roboto-slab"
    >
      <h4 class="mr-4 flex-1 sm:text-sm text-xs">{{ article.title }}</h4>
      <!-- author not in EP -->
      <strong v-if="false" class="flex flex-row gap-1 items-center" />
      <!-- readTime not in EP -->
      <strong v-if="false" class="flex flex-row gap-1 items-center" />
    </a>
  </article>
</template>
